<header-title [model]="headerTitle"></header-title>


<div class="container-fluid py-4">
    <div class="row row-cols-1 row-cols-lg-3 g-4">

      <div class="col col-12 col-lg-3">
        <div class="card" *ngIf="companyAuditModel">
          <div class="card-header d-flex align-items-center justify-content-between">
            <h4 class="card-title"><i class="fa fa-fw fa-tasks"></i>{{companyAuditModel.title}}</h4>
            <a href="#" class="float-end text-primary" data-bs-toggle="collapse" data-bs-target="#collapseCard1">
              <i class="fa fa-chevron-down"></i>
            </a>
          </div>
          <!-- Card body with a unique id and collapse class -->
          <div id="collapseCard1" class="collapse show">
            <div class="card-body">
              <div class="mb-3">
                <button class="btn btn-link btn-sm text-decoration-none mb-3" [routerLink]="['/company-audit/', auditId ]"><span class="fas fa-arrow-left me-2"></span>Back to Audit Summary</button>
                <!-- <a class="btn btn-outline-primary btn-sm w-100 mb-3" [ngClass]="{'btn-primary-dark':m.id==moduleId}" *ngFor="let m of selectedModules; index as i" [routerLink]="['/company-audit','view',m.companyAuditId,m.id]">{{m.moduleDescription}}</a> -->
                <a class="btn btn-outline-primary btn-sm w-100 mb-3" [ngClass]="{'btn-primary-dark':m.id==moduleId}" *ngFor="let m of selectedModules; index as i" (click)="switchModule(m.id)">{{m.moduleDescription}}</a>

              </div>
            </div>
            <div class="card-footer border-0 bg-white pb-3">
            </div>
          </div>
        </div>

        <div class="card mt-3" *ngIf="auditModule">
          <div class="card-header d-flex align-items-center justify-content-between">
            <h4 class="card-title"><i class="fa fa-fw fa-tasks"></i>{{auditModule.moduleDescription}}</h4>
            <a href="#" class="float-end text-primary" data-bs-toggle="collapse" data-bs-target="#collapseCard2">
              <i class="fa fa-chevron-down"></i>
            </a>
          </div>
          <!-- Card body with a unique id and collapse class -->
          <div id="collapseCard2" class="collapse show">
            <div class="card-body">
              <div class="mb-3">
                <ul class="list-unstyled">
                    <li class="d-flex justify-content-between py-2 border-bottom" *ngIf="auditModule.customerSurname">
                        <label class="text-sm text-muted">Customer</label> {{auditModule.customerInitial}} {{auditModule.customerSurname}}
                    </li>
                    <li class="d-flex justify-content-between py-2 border-bottom" *ngIf="auditModule.brokerName">
                        <label class="text-sm text-muted">Broker</label> {{auditModule.brokerName}}
                    </li>
                    <li class="d-flex justify-content-between py-2 border-bottom" *ngIf="auditModule.lenderName">
                        <label class="text-sm text-muted">Lender</label> {{auditModule.lenderName}}
                    </li>
                    <li class="d-flex justify-content-between py-2 border-bottom">
                        <label class="text-sm text-muted">Created</label> {{companyAuditModel.startDate | date:'dd/MM/yyyy'}}
                    </li>
                    <li class="d-flex justify-content-between py-2 border-bottom">
                        <label class="text-sm text-muted">Type</label> {{companyAuditModel.auditTemplateDescription}}
                    </li>
                    <li class="d-flex justify-content-between py-2 border-bottom" *ngIf="companyAuditModel.customerSurname">
                        <label class="text-sm text-muted">Customer</label> {{companyAuditModel.customerSurname}}
                        {{companyAuditModel.customerInitial}}
                    </li>
                    <li class="d-flex justify-content-between py-2 border-bottom">
                        <label class="text-sm text-muted">Status</label>
                        <span class="far fa-circle text-primary" *ngIf="companyAuditModel.auditStatus==0" data-toggle="tooltip"
                            title="Open"></span>
                        <span class="fas fa-circle text-primary" *ngIf="companyAuditModel.auditStatus==1" data-toggle="tooltip"
                            title="Completed"></span>
                    </li>
                    <li class="d-flex justify-content-between py-2 border-bottom" *ngIf="companyAuditModel.completedDate">
                        <label class="text-sm text-muted">Completed</label> {{companyAuditModel.completedDate | date:'dd/MM/yyyy'}}
                    </li>
                    <li class="d-flex justify-content-between py-2 border-bottom" *ngIf="companyAuditModel.auditStatus==1">
                        <label class="text-sm text-muted">Rating</label>
                        <span *ngIf="totalPercentage<=25" data-toggle="tooltip" title="Positive - Well Done"><span
                                class="fas fa-circle text-success"></span></span>
                        <span *ngIf="totalPercentage>25&&totalPercentage<=75" data-toggle="tooltip" title="OK - Needs Attention"><span
                                class="fas fa-circle text-warning"></span></span>
                        <span *ngIf="totalPercentage>75" data-toggle="tooltip" title="Poor - High Risk"><span
                                class="fas fa-circle text-danger"></span></span>
                    </li>
                </ul>
              </div>
            </div>
            <div class="card-footer border-0 bg-white pb-3">
                <div *ngIf="companyAuditModel.auditCategoryId==1">
                    <button class="btn btn-primary w-100" (click)="downloadReport(companyAuditModel.auditCategoryId, companyAuditModel.id)" *ngIf="!reportDownloading && companyAuditModel.auditStatus==1"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> {{reportDownloaded ? 'Report Downloaded' : 'Download Report'}}</button>
                    <div class="card card-info" *ngIf="reportDownloading"><div class="card-body text-center"><p>PDF compile commenced</p><i class="fa fa-spin fa-spinner"></i></div></div>
                </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col col-12 col-lg-9">
        <div class="card mb-4" *ngIf="auditModule">

          <div class="card-header d-flex align-items-center justify-content-between">
            <h4 class="card-title"><i class="fa fa-fw fa-cube"></i>{{auditModule.moduleDescription}}</h4>
          </div>

          <div class="card-body py-3">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 audit-document-details">
                        <ul class="list-inline">
                            <li class="list-inline-item">
                                <label [class.text-danger]="auditDocuments?.length==0">
                                    <span class="fas fa-file"></span> <span *ngIf="auditDocuments"> {{auditDocuments?.length}}</span> Document<span *ngIf="auditDocuments?.length!=1">s</span> uploaded
                                </label>
                            </li>
                            <li class="list-inline-item" *ngIf="auditDocuments && auditDocuments.length>0">
                                <button data-bs-toggle="collapse" data-bs-target="#audit-document-view" class="btn btn-link" title="View uploaded documents" *ngIf="auditDocuments.length>0"><span class="fas fa-eye"></span> View</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-12 collapse" id="audit-document-view">
                        <table class="table table-bordered">
                            <tbody>
                                <tr *ngFor="let doc of auditDocuments">
                                    <td><span class="fas fa-file"></span> {{doc.fileName}}</td>
                                    <td class="text-right">
                                        <a href="javascript:undefined;" (click)="this.companyAuditService.downloadGeneratedDocument(doc.id)"><span class="fas fa-download"></span> Download</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-12 collapse" id="audit-document-upload">
                        <div *ngIf="auditModule" class="card-body py-5">
                            <app-document [companyAuditId]="auditModule.companyAuditId"
                                          [moduleId]="moduleId"
                                            (documentUploaded)="onDocumentUploaded($event)">
                            </app-document>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row qb-nav">
                    <div class="col-3 col-sm-2 col-lg-1 text-right"><button class="btn btn-link" [ngClass]="{'disabled': pageNumber == 0}" (click)="pageDown()" data-toggle="tooltip" data-placement="top" title="Previous"><i class="fas fa-chevron-circle-left"></i></button></div>
                    <div class="col-6 col-sm-8 col-lg-10">
                        <h5 class="text-center">Step {{pageNumber + 1}} of {{questionsModel?.length}}</h5>
                        <div class="progress progress-xs m-2 light" style="height: 10px;">
                            <div class="progress-bar bg-primary" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" [style.width.%]="progress">
                                <span class="sr-only">{{progress}}%</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 col-sm-2 col-lg-1 text-left" *ngIf="questionsModel"><button class="btn btn-link" [ngClass]="{'disabled': pageNumber == questionsModel.length - 1}" (click)="pageUp()" data-toggle="tooltip" data-placement="top" title="Next"><i class="fas fa-chevron-circle-right"></i></button></div>
                </div>
            </div>

            <div class="container">
                <div class="row mt-5" *ngFor="let item of questionsModel; let i = index;" [hidden]="i!=pageNumber">
                    <div class="col">
                        <section class="border rounded question-bank">
                            <header class="card-header clearfix">
                                <div class="row">
                                    <div class="col">
                                        <h2 class="card-title">{{item.questionBankName}}</h2>
                                    </div>
                                    <div class="col">
                                        <p class="text-end">
                                            Section Rating:
                                            <span *ngIf="(item.score/(item.questions.length*2)*100)<=25"><span
                                                    class="badge badge-pill text-bg-success badge-wrap text-2 font-weight-normal px-2 py-1">Positive -
                                                    Well Done</span></span>
                                            <span
                                                *ngIf="(item.score/(item.questions.length*2)*100)>25&&(item.score/(item.questions.length*2)*100)<=75"><span
                                                    class="badge badge-pill text-bg-warning badge-wrap text-2 font-weight-normal px-2 py-1">OK - Needs
                                                    Attention</span></span>
                                            <span *ngIf="(item.score/(item.questions.length*2)*100)>75"><span
                                                    class="badge badge-pill text-bg-danger badge-wrap text-2 font-weight-normal px-2 py-1">Poor - High
                                                    Risk</span></span>
                                            <span style="display:none">{{item.score}}/{{item.questions.length*2}}
                                                {{item.score/(item.questions.length*2)*100}}</span>
                                        </p>
                                    </div>
                                </div>
                            </header>
                            <div class="card-body py-5">
                                <div class="panel-body">
                                    <div class="row row d-flex justify-content-center">
                                        <div class="col-12">
                                            <ng-container *ngFor="let question of item.questions">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="row mt-3">
                                                            <div class="col-md-5">
                                                                <label class="control-label question-label" [attr.for]="question.key" [innerHtml]="question.label"></label>
                                                            </div>
                                                            <div class="col-md-6"><p>{{question.value}}</p></div>
                                                            <div class="col-md-1 score-flag text-right">
                                                                <span class="fa fa-check-circle text-success" *ngIf="question.score==0"></span>
                                                                <span class="fa fa-info-circle text-warning" *ngIf="question.score==1"></span>
                                                                <span class="fa fa-times-circle text-danger" *ngIf="question.score>=2"></span>
                                                            </div>
                                                        </div>
                                                        <div class="row" *ngIf="question.comment?.length>0">
                                                            <div class="col-12">
                                                                <div class="alert" [ngClass]="{'alert-danger':question.score>=2,'alert-warning':question.score==1,'alert-success':question.score==0}">
                                                                    {{question.comment}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row d-none">
                                                            <div class="col-12">
                                                                Score: {{question.score}}
                                                            </div>
                                                        </div>
                                                        <div class="question-divider"></div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

            <div class="container mt-3">
                <div class="row">
                    <div class="col text-end">
                        <button class="btn btn-primary ml-1" type="button" (click)="pageUp()" *ngIf="(pageNumber + 1) < questionsModel?.length">Next</button>
                    </div>
                </div>
            </div>


          </div>
        </div>
      </div>

    </div>
  </div>
